import { atom } from "recoil";

const numeroAtomicoState = atom({
  key: "numeroAtomicoState", // unique ID (with respect to other atoms/selectors)
  default: 0, // default value (aka initial value)
});
export default numeroAtomicoState;
